import { FETCHING_ADVISORPROFILECONTAINER_PROFILE,
  FETCHED_ADVISORPROFILECONTAINER_PROFILE } from './adviserProfileContainerActions'

const initialState = {
  loading: true,
  profile: {
    isIndependent: false
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCHING_ADVISORPROFILECONTAINER_PROFILE:
      return initialState
    case FETCHED_ADVISORPROFILECONTAINER_PROFILE:
      return { loading: false, profile: action.payload }
    default:
      return state
      }
  }
